import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import DatabaseFilledSvg from "@ant-design/icons-svg/es/asn/DatabaseFilled";
import AntdIcon from "../components/AntdIcon";
var DatabaseFilled = function DatabaseFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DatabaseFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  DatabaseFilled.displayName = 'DatabaseFilled';
}
export default /*#__PURE__*/React.forwardRef(DatabaseFilled);